import { toFormikValidationSchema } from "zod-formik-adapter";

import type { IShapeOfForm } from "@utils";
import { z } from "@utils";

export interface IChatValues {
  text: string;
}

export const chatSchema = toFormikValidationSchema(
  z.object<IShapeOfForm<IChatValues>>({
    text: z.string(),
  }),
);
